import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { hideModal } from "../../store/slice/modalSlice";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import api from "../../api/endpoints";
import http from "../../api/httpService";
import { useAppSelector } from "../../store/hooks";
import {
  temporaryQuery,
  temporaryQueryConstructor,
} from "../../screens/AdvancedSearch/TemporaryQueryConstructor";
import {
  clearClassificationNum,
  clearCPCClassificationNum,
  clearMeshKeyword,
  clearSearchTerm,
  clearSubstances,
  updateAllFacets,
  updateAuthorFacets,
  updateDataType,
  updateFullText,
  updateLinkToDisplay,
  updateMeshKeyword,
  updateMeshKeywords,
  updatePage,
  updateRow,
  updateSavedArticles,
  updateSearchResults,
  updateSubjectFacets,
  updateSubjectName,
  updateSubjectType,
} from "../../store/slice/searchSlice";
import {
  clearAllFiltersValue,
  updataLibraryOpac,
  updateAllFilter,
  updateDSPACECollection,
  updateIsOpac_dspace,
  updateSort,
} from "../../store/slice/filterSlice";
import { updateQueries } from "../../store/slice/appliedQueries";
import { queryConstructor } from "../../api/formQuery";
import { updateQuery } from "../../store/slice/queryForCountSlice";
import { basicSearchQuery } from "../../api/Search/BasicSearch.api";
import { getBulkLinkRecords } from "../../api/linkResolverApi";
import { checkMultipleArticleExistence } from "../../api/MyLibrary/MyFolders.api";
// import { useNavigate } from "react-router-dom";

interface PropType {
  isOpen: boolean;
  data?: any;
  navigate?: any;
  selectedTags?: any;
  selectedSubjects?: any;
  selectedSubjectNames?: any;
  subjectData?: any;
}

export default function MeshKeywordsModel(props: PropType) {
  const {
    isOpen,
    data,
    navigate,
    selectedSubjects,
    selectedTags,
    selectedSubjectNames,
    subjectData,
  } = props;
  const dispatch = useDispatch();
  //   const navigate = useNavigate();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  const [selectedLetter, setSelectedLetter] = useState<string | null>(null);
  const [keywords, setKeywords] = useState<string[]>([]);
  const [selectedKeywords, setSelectedKeywords] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingResults, setLodingResults] = useState(false);

  const customerData = useAppSelector(
    (state) => state.customer.customerDetails,
  );

  const profileData = useAppSelector((state) => state.login);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;

  const l1SubjectIds = useAppSelector(
    (state) => state.searchReducer.subjectL1Type,
  );
  const uniqueIds = [...new Set(l1SubjectIds || [])];
  const encodedSubjectIds = temporaryQueryConstructor(uniqueIds);

  const numbers = Array.from({ length: 10 }, (_, i) => i.toString());
  const letter = Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode(65 + i),
  );
  const letters = [...numbers, ...letter];

  useEffect(() => {
    if (selectedLetter !== null) {
      fetchKeywords(selectedLetter);
    }
  }, [selectedLetter]);

  const fetchKeywords = async (letter: string) => {
    const prefix = letter.toLowerCase();
    setLoading(true);
    try {
      let url = `${
        api.baseApi
      }/api/indexingGen/solrGeneral/autofillcore?page=1&rows=1&facet_limit=500&facet_fields=keyword&fq__mesh_key=true&datsubjectmasterlevel1_ids=(${encodedSubjectIds.toLowerCase()})&facet_prefix=${prefix}${
        searchTerm !== "" ? `&facet_prefix=${searchTerm}` : ""
      }`;

      const res = await http.get(url);
      const fetchedKeywords =
        res?.data?.data?.facets?.facet_fields?.keyword.map(
          (item: any) => Object.keys(item)[0],
        ) || [];
      setKeywords(fetchedKeywords);
      setCurrentPage(1); // Reset page when new data is fetched
    } catch (error) {
      console.error("Error fetching keywords", error);
      setKeywords([]);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (keyword: string) => {
    setSelectedKeywords((prev) =>
      prev?.includes(keyword)
        ? prev?.filter((k) => k !== keyword)
        : [...prev, keyword],
    );
  };

  async function linkToDisplay(dataArray: any) {
    if (!Array.isArray(dataArray)) return;
    let formData = new FormData();

    let data = dataArray?.map((obj: any) => {
      let object: any = {
        customer_id: customerData?.informaticscustomer_id,
        article_id: obj?.article_id,
        consortia_virtualid: customerData?.consortia_virtualid,
        resource_type: obj?.resource_type,
        access_type: obj?.article_open_status || obj?.access_type_id || null,
        is_oa_article: obj?.fulltext || false,
      };

      if (obj?.articledoi) {
        object.article_doi = obj?.articledoi;
      }

      if (obj?.resourceissue_id) {
        object.resourceissue_id = obj?.resourceissue_id;
      }

      if (obj?.is_onos_resource) {
        object.is_onos_resource = true;
      }

      return object;
    });

    let formApiData = {
      data,
    };

    formData.append("detailed_json", JSON.stringify(formApiData));
    const response = await getBulkLinkRecords(formData);

    if (response?.message === "Ok") {
      dispatch(updateLinkToDisplay(response?.data));
    }
  }

  const handleApply = async () => {
    setLodingResults(true);
    dispatch(clearSearchTerm());
    dispatch(clearMeshKeyword());
    dispatch(clearSubstances());
    dispatch(clearAllFiltersValue());
    dispatch(clearClassificationNum());
    dispatch(clearCPCClassificationNum());

    let meshKeywords = `(${temporaryQuery(selectedKeywords)})`;

    const searchedData = {
      key: "search-term",
      value: meshKeywords,
    };

    //Update States
    dispatch(updateAllFilter(searchedData));
    // dispatch(updateSearchTerm(searchterm.trim()));
    dispatch(updateSubjectType(selectedSubjects));
    dispatch(updateSubjectName(selectedSubjectNames));
    dispatch(updateRow(15));
    dispatch(updatePage(1));
    dispatch(updateSort("dateofpublication desc"));
    dispatch(updateQueries(searchedData));
    dispatch(updateMeshKeywords(selectedKeywords));

    //filter Facet states
    dispatch(updateSubjectFacets([]));
    dispatch(updateAuthorFacets([]));
    dispatch(updateAllFacets([]));

    let encodedSubjects = "";
    if (selectedSubjects.length === 0) {
      encodedSubjects = `(${temporaryQueryConstructor(
        subjectData?.map((x: any) => x.datsubjectmasterlevel2_id),
      )})`;
    } else {
      encodedSubjects = `(${temporaryQueryConstructor(selectedSubjects)})`;
    }

    let encodedTags = "";
    let tags = [...selectedTags];
    if (tags?.includes(1) && !tags?.includes(2)) tags.push(2);
    if (tags?.includes(1) && !tags?.includes(5)) tags.push(5);
    if (tags?.includes(1) && !tags?.includes(24)) tags.push(24);

    if (!tags?.includes(1) && tags?.includes(2))
      tags = tags.filter((tag) => tag !== 2);
    if (!tags?.includes(1) && tags?.includes(5))
      tags = tags?.filter((tag) => tag !== 5);
    if (!tags?.includes(1) && tags?.includes(24))
      tags = tags.filter((tag) => tag !== 24);

    dispatch(updateDataType(tags));

    if (tags.length === 0) {
      encodedTags = "( 1 OR 4 OR 2 OR 3 OR 8 OR 24 )";
    } else if (
      tags.length === 2 &&
      tags?.includes(100) &&
      tags?.includes(101)
    ) {
      encodedTags = "(100 OR 101)";
    } else if (tags.length === 1 && (tags[0] === 100 || tags[0] === 101)) {
      encodedTags = `(${tags[0]})`;
    } else {
      encodedTags = `(${temporaryQueryConstructor(tags)})`;
    }

    const queryObj: any = {
      mesh_keywords: meshKeywords,
      sort: "dateofpublication desc",
      fq__resource_type: encodedTags,
      rows: 15,
      op_mode: "and",

      sessionid: sessionStorage.getItem("session_key"),
      profileuserid: sessionStorage.getItem("user_id"),
      datsearchtype_id: "1",
      customerid: sessionStorage.getItem("informaticscustomer_id"),
    };

    if (
      encodedSubjects &&
      selectedSubjects.length
      //  &&
      // !selectedSubjects.includes(0)
    ) {
      queryObj.fq__subjects_id_l2 = encodedSubjects;
    }

    const isOnlyConsortiaAccess = customerData?.product_type === "7";
    if (isOnlyConsortiaAccess) {
      queryObj.fq__acl_group = customerData.consortia_filter;
    }

    const customerId =
      profileData &&
      profileData.informaticscustomer_id &&
      profileData.informaticscustomer_id !== "undefined"
        ? profileData.informaticscustomer_id
        : "0";
    const fullTextQuery = await queryConstructor({
      ...queryObj,
      // fq__fulltext: true,
      "fq__(fulltext": `true OR acl_group=(${customerId}))`,
    });

    const fullTextQueryHistory = await queryConstructor({
      ...queryObj,
      //fq__fulltext: true,
      "fq__(fulltext": `true OR acl_group=(${customerId}))`,
    });

    const allQuery = await queryConstructor({
      ...queryObj,
    });

    const logSearchQuery = await queryConstructor({
      ...queryObj,
      logsearchhistory: true,
    });

    dispatch(
      updateQuery({
        fullTextQuery: fullTextQuery,
        allTextQuery: allQuery,
      }),
    );

    dispatch(updateDSPACECollection(false));
    dispatch(updataLibraryOpac(false));
    dispatch(updateIsOpac_dspace(false));

    const allCountFromLog = await basicSearchQuery(logSearchQuery);
    const fullTextData = await basicSearchQuery(fullTextQueryHistory);
    // await linkToDisplay(fullTextData?.docs);
    dispatch(updateSearchResults(fullTextData));
    dispatch(updateFullText(true));
    setLodingResults(false);

    navigate("/basicSearchScreen?searchterm=", {
      state: {
        // searchTerm: selectedKeywords,
        fullTextQuery: fullTextQuery,
        allQuery: allQuery,
        from: "basic",
      },
    });

    //alert("testing");
    dispatch(hideModal());
  };

  const handleCancel = () => {
    dispatch(hideModal());
  };

  const handleSearchClick = () => {
    if (selectedLetter) {
      fetchKeywords(selectedLetter);
    }
  };

  const filteredKeywords = keywords.filter((k) =>
    k.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const totalPages = Math.ceil(keywords.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentKeywords = keywords.slice(indexOfFirstItem, indexOfLastItem);

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => dispatch(hideModal())}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          fontFamily="Lora"
          sx={{ fontSize: { xs: "20px", sm: "22px", md: "22px" } }}
        >
          MeSH Keywords
        </Typography>
        <IconButton onClick={() => dispatch(hideModal())}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ mt: 1 }}>
        {/* Alphabet / Number Buttons */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            mb: 2,
            //justifyContent: "center",
            justifyContent: "flex-start",
          }}
        >
          {letters.map((letter) => (
            <Button
              key={letter}
              variant={selectedLetter === letter ? "contained" : "outlined"}
              size={isXs ? "small" : "small"}
              //onClick={() => setSelectedLetter(letter)}
              onClick={() => {
                if (selectedLetter === letter) {
                  setSelectedLetter(null); // Unselect if clicked again
                  setKeywords([]);
                } else {
                  setSelectedLetter(letter); // Select new alphabet
                  setSearchTerm(""); // Clear search when changing alphabet
                }
              }}
              sx={{
                minWidth: "36px",
                fontSize: { xs: "10px", sm: "12px", md: "14px" },
              }}
            >
              {letter}
            </Button>
          ))}
        </Box>

        {/* Search Field + Button */}
        <Box
          sx={{
            display: "flex",
            gap: 1,
            mb: 2,
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <TextField
            fullWidth
            placeholder="Search keywords..."
            size={isXs ? "small" : "medium"}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button
            variant="contained"
            size={isXs ? "small" : "medium"}
            onClick={handleSearchClick}
            sx={{ minWidth: { xs: "100%", sm: "100px" } }}
            disabled={!selectedLetter || selectedLetter.trim() === ""}
          >
            Search
          </Button>
        </Box>

        {/* Keywords List */}
        <Box
          sx={{
            maxHeight: "300px",
            overflowY: "auto",
            border: "1px solid #ddd",
            borderRadius: "4px",
            p: 1,
          }}
        >
          {loading ? (
            <Typography sx={{ textAlign: "center", p: 2 }}>
              Loading...
            </Typography>
          ) : currentKeywords.length > 0 ? (
            currentKeywords.map((keyword) => (
              <Box
                key={keyword}
                sx={{ display: "flex", alignItems: "center", p: "4px 0" }}
              >
                <Checkbox
                  checked={selectedKeywords?.includes(keyword)}
                  onChange={() => handleToggle(keyword)}
                />
                <Typography
                  sx={{ fontSize: { xs: "12px", sm: "14px", md: "16px" } }}
                >
                  {keyword}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography sx={{ textAlign: "center", p: 2 }}>
              No keywords found
            </Typography>
          )}
        </Box>

        {/* Pagination Controls */}
        {keywords.length > itemsPerPage && (
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Button>
            <Typography sx={{ alignSelf: "center" }}>
              Page {currentPage} of {totalPages}
            </Typography>
            <Button onClick={handleNext} disabled={currentPage === totalPages}>
              Next
            </Button>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, justifyContent: "center" }}>
        <Button
          onClick={handleCancel}
          sx={{ fontSize: { xs: "12px", sm: "14px" } }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleApply}
          variant="contained"
          sx={{ fontSize: { xs: "12px", sm: "14px" } }}
          disabled={selectedKeywords.length <= 0}
        >
          {loadingResults ? (
            <CircularProgress size={24} sx={{ color: "#fff" }} />
          ) : (
            "Apply"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
